import { supabase } from '../lib/supabase';

export const pageService = {
  /**
   * Get settings for a specific page by its slug
   */
  async getPageSettings(slug) {
    const { data, error } = await supabase
      .from('page_settings')
      .select('*')
      .eq('slug', slug)
      .maybeSingle();

    if (error) throw error;
    return data;
  }
};
